export default "__VITE_ASSET__In3U_dtB__"